/**
 * 2026 Harley-Davidson FAT BOY® 配置数据
 * 完全复刻美国哈雷官网定制器数据
 */

// 基础车型信息
export const BIKE_INFO = {
    id: '2026-fat-boy',
    name: '2026 FAT BOY®',
    year: 2026,
    baseMSRP: null, // 基础价格未单独显示
    configuredMSRP: 27451.35 // 当前配置价格
};

// 基础价格 (美元)
export const BASE_PRICE = 27451.35;

// 分类定义
export const CATEGORIES = [
    {
        id: 'trim',
        nameKey: 'categories.trim',
        type: 'single_select',
        viewPoint: { x: 0, y: 0, scale: 1 }
    },
    {
        id: 'body',
        nameKey: 'categories.body',
        type: 'single_select',
        viewPoint: { x: 0, y: 0, scale: 1 }
    },
    {
        id: 'comfort',
        nameKey: 'categories.comfort',
        description: 'categories.comfort_desc',
        type: 'multi_select',
        viewPoint: { x: -10, y: -10, scale: 1.5 }
    },
    {
        id: 'performance',
        nameKey: 'categories.performance',
        description: 'categories.performance_desc',
        type: 'single_select',
        viewPoint: { x: 10, y: 25, scale: 1.8 }
    },
    {
        id: 'style',
        nameKey: 'categories.style',
        description: 'categories.style_desc',
        type: 'multi_select',
        note: 'categories.style_note',
        viewPoint: { x: -20, y: -10, scale: 1.5 }
    }
];

// 配件数据
export const PARTS = {
    // TRIM - 装饰风格 (单选)
    trim: [
        {
            id: 'chrome',
            nameKey: 'parts.trim.chrome',
            price: 0,
            priceType: 'default',
            isDefault: true
        }
    ],

    // BODY - 车身颜色 (单选)
    body: [
        {
            id: 'dark_billiard_gray',
            nameKey: 'parts.body.dark_billiard_gray',
            price: 0,
            priceType: 'default',
            isDefault: true,
            colorCode: '#5A5A5A',
            image: '/assets/360/2026-fat-boy-m85-motorcycle/2026-fat-boy-m85-motorcycle-01.jpg'
        },
        {
            id: 'vivid_black',
            nameKey: 'parts.body.vivid_black',
            price: 300,
            priceType: 'additional',
            isDefault: false,
            colorCode: '#000000',
            image: '/assets/360/2026-fat-boy-m04-motorcycle/2026-fat-boy-m04-motorcycle-01.jpg'
        },
        {
            id: 'white_onyx_pearl',
            nameKey: 'parts.body.white_onyx_pearl',
            price: 650,
            priceType: 'additional',
            isDefault: false,
            colorCode: '#8C8C8C',
            image: '/assets/360/2026-fat-boy-m07-motorcycle/2026-fat-boy-m07-motorcycle-01.jpg'
        },
        {
            id: 'brilliant_red',
            nameKey: 'parts.body.brilliant_red',
            price: 650,
            priceType: 'additional',
            isDefault: false,
            colorCode: '#CC0000',
            image: '/assets/360/2026-fat-boy-m44-motorcycle/2026-fat-boy-m44-motorcycle-01.jpg'
        },
        {
            id: 'olive_steel_metallic_vivid_black',
            nameKey: 'parts.body.olive_steel_metallic_vivid_black',
            price: 1100,
            priceType: 'additional',
            isDefault: false,
            colorCode: '#556B2F',
            isTwoTone: true,
            image: '/assets/360/2026-fat-boy-m78-motorcycle/2026-fat-boy-m78-motorcycle-01.jpg'
        }
    ],

    // COMFORT - 舒适配件 (多选)
    comfort: [
        {
            id: 'sissy_bar_upright',
            nameKey: 'parts.comfort.sissy_bar_upright',
            price: 397.85,
            itemCount: 3,
            isPackage: true,
            items: [
                { name: 'HoldFast Sissy Bar Upright - Standard Height - Chrome', quantity: 1 },
                { name: 'Passenger Backrest Pad - Mid-Sized - Smooth Black Vinyl', quantity: 1 },
                { name: 'HoldFast Docking Hardware Kit - Chrome', quantity: 2 }
            ],
            image: '/assets/parts/sissy_bar_upright.jpg'
        },
        {
            id: 'get_a_grip_handgrips_chrome',
            nameKey: 'parts.comfort.get_a_grip_handgrips',
            price: 114.95,
            itemCount: 1,
            isPackage: true,
            items: [
                { name: 'Get-A-Grip Hand Grips', quantity: 1 }
            ],
            image: '/assets/parts/handgrips.jpg'
        },
        {
            id: 'detachable_saddlebags',
            nameKey: 'parts.comfort.detachable_saddlebags',
            price: 1212.85,
            itemCount: 3,
            isPackage: true,
            items: [
                { name: 'HoldFast Docking Hardware Kit - Chrome', quantity: 1 },
                { name: 'H-D Detachables Locking Saddlebags', quantity: 1 },
                { name: 'Rear Turn Signal/License Plate Relocation Kit - Chrome', quantity: 1 }
            ],
            image: '/assets/parts/saddlebags.jpg'
        },
        {
            id: 'detachable_windshield',
            nameKey: 'parts.comfort.detachable_windshield',
            price: 459.95,
            itemCount: 1,
            isPackage: true,
            items: [
                { name: 'Wind Splitter Detachable Compact 15 in. Windshield', quantity: 1 }
            ],
            image: '/assets/parts/windshield.jpg'
        },
        {
            id: 'hammock_comfort_seat',
            nameKey: 'parts.comfort.hammock_comfort_seat',
            price: 619.95,
            itemCount: 1,
            isPackage: true,
            items: [
                { name: 'Harley Hammock Touring Seat', quantity: 1 }
            ],
            image: '/assets/parts/hammock_seat.jpg'
        },
        {
            id: 'engine_guard',
            nameKey: 'parts.comfort.engine_guard',
            price: 299.95,
            itemCount: 1,
            isPackage: true,
            items: [
                { name: 'Engine Guard Kit', quantity: 1 }
            ],
            image: '/assets/parts/engine_guard.jpg'
        },
        {
            id: 'long_haul_flfb',
            nameKey: 'parts.comfort.long_haul_flfb',
            price: 3162.50,
            itemCount: 10,
            isPackage: true,
            isBundlePackage: true,
            note: 'Comprehensive touring package',
            items: [
                { name: 'HoldFast Sissy Bar Upright - Standard Height - Chrome', quantity: 1 },
                { name: 'Get-A-Grip Hand Grips', quantity: 1 },
                { name: 'Passenger Backrest Pad - Mid-Sized - Smooth Black Vinyl', quantity: 1 },
                { name: 'HoldFast Docking Hardware Kit - Chrome', quantity: 1 },
                { name: 'H-D Detachables Locking Saddlebags', quantity: 1 },
                { name: 'Rear Turn Signal/License Plate Relocation Kit - Chrome', quantity: 1 },
                { name: 'Wind Splitter Detachable Compact 15 in. Windshield', quantity: 1 },
                { name: 'Harley Hammock Touring Seat', quantity: 1 },
                { name: 'Engine Guard Kit', quantity: 1 },
                { name: 'Chrome Heel Shifter Lever', quantity: 1 }
            ],
            image: '/assets/parts/long_haul_package.jpg'
        }
    ],

    // PERFORMANCE - 性能配件 (单选)
    performance: [
        {
            id: 'none',
            nameKey: 'parts.performance.none',
            price: 0,
            priceType: 'default',
            isDefault: true,
            itemCount: 0,
            items: []
        },
        {
            id: 'heavy_breather_air_cleaner_chrome',
            nameKey: 'parts.performance.heavy_breather',
            price: 1074.90,
            itemCount: 2,
            isPackage: true,
            items: [
                { name: "Screamin' Eagle Pro Street Tuner", quantity: 1 },
                { name: "Screamin' Eagle Heavy Breather Extreme Air Cleaner", quantity: 1 }
            ],
            image: '/assets/parts/heavy_breather.jpg'
        },
        {
            id: 'wedge_air_cleaner_chrome',
            nameKey: 'parts.performance.wedge_air_cleaner',
            price: 999.90,
            itemCount: 2,
            isPackage: true,
            items: [
                { name: "Screamin' Eagle Pro Street Tuner", quantity: 1 },
                { name: "Screamin' Eagle Air Cleaner - Extreme Wedge", quantity: 1 }
            ],
            image: '/assets/parts/wedge_air_cleaner.jpg'
        },
        {
            id: 'round_air_cleaner',
            nameKey: 'parts.performance.round_air_cleaner',
            price: 724.90,
            itemCount: 2,
            isPackage: true,
            items: [
                { name: "Screamin' Eagle Pro Street Tuner", quantity: 1 },
                { name: "Screamin' Eagle Extreme Air Cleaner - Circle", quantity: 1 }
            ],
            image: '/assets/parts/round_air_cleaner.jpg'
        },
        {
            id: 'vh_hi_output_slip_on',
            nameKey: 'parts.performance.vh_hi_output_slip_on',
            price: 549.95,
            itemCount: 1,
            isPackage: true,
            isThirdParty: true,  // 第三方配件标识
            brand: 'Vance & Hines',
            sku: '18627',
            items: [
                { name: 'Hi-Output Slip-On Muffler', quantity: 1 }
            ],
            features: [
                'Bold Stepped Muffler Design',
                'CNC Machined Billet End Cap',
                'Laser Engraved Logo Badge',
                'Chrome or Black Finish',
                'Made in USA'
            ],
            descriptionKey: 'parts.performance.vh_hi_output_slip_on_desc',
            image: '/assets/parts/48627_3.jpg',
            soundUrl: '/assets/audio/VH_18627_48627_HIOUTPUT_SLIPON_SCOUT.mp3'
        }
    ],

    // STYLE - 风格配件 (多选)
    style: [
        {
            id: 'empire_collection',
            nameKey: 'parts.style.empire_collection',
            price: 974.75,
            itemCount: 5,
            isPackage: true,
            items: [
                { name: 'Empire Rider Footboard Kit', quantity: 1 },
                { name: 'Empire Passenger Footpegs', quantity: 1 },
                { name: 'Empire Large Rear Brake Pedal Pad', quantity: 1 },
                { name: 'Empire Shifter Peg', quantity: 1 },
                { name: 'Empire Derby Cover', quantity: 1 }
            ],
            image: '/assets/parts/empire_collection.jpg'
        }
    ]
};

// 默认配置
export const DEFAULT_CONFIG = {
    trim: 'chrome',
    body: 'dark_billiard_gray',
    comfort: [], // 多选，默认无
    performance: 'none', // 单选，默认无
    style: [] // 多选，默认无
};

// 辅助函数：获取分类类型
export const getCategoryType = (categoryId) => {
    const category = CATEGORIES.find(c => c.id === categoryId);
    return category?.type || 'single_select';
};

// 辅助函数：判断分类是否为多选
export const isMultiSelect = (categoryId) => {
    return getCategoryType(categoryId) === 'multi_select';
};

// 辅助函数：获取配件详情
export const getPartById = (categoryId, partId) => {
    return PARTS[categoryId]?.find(p => p.id === partId);
};

// 辅助函数：计算选装包包含的配件总数
export const getPackageItemCount = (part) => {
    if (!part?.items) return 0;
    return part.items.reduce((sum, item) => sum + item.quantity, 0);
};
